<div class="modal fade" id="modalExport" aria-hidden="true" aria-labelledby="exampleModalToggleLabel" tabindex="-1">
    <div class="modal-dialog modal-dialog-centered modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalToggleLabel">XUẤT FILE</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body col-sm-12 d-flex">
                <div class="col-sm-3 d-flex gap-3">
                    <InputTextNormal
                            :label="dataModal.file_name.label"
                            :id="dataModal.file_name.id"
                            :placeholder="dataModal.file_name.placeholder"
                            :value-default="dataModal.file_name.value"
                            @inputValue="onChange($event, dataModal.file_name.id)"
                            :required="dataModal.file_name.required"
                            :disabled="dataModal.file_name.disable"
                    ></InputTextNormal>
                </div>
                <div class="col-sm-3 d-flex gap-3">
                    <SelectNormal
                            :label="dataModal.name.label"
                            :id="dataModal.name.id"
                            :placeholder="dataModal.name.placeholder"
                            :value-default="dataModal.name.value"
                            @inputValue="onChange($event, dataModal.name.id)"
                            :required="dataModal.name.required"
                            :disabled="dataModal.name.disable"
                            :options="dataModal.name.options"
                    ></SelectNormal>
                </div>
                <div class="col-sm-3 d-flex gap-3">
                    <InputTextNormal
                            :label="dataModal.table_use.label"
                            :id="dataModal.table_use.id"
                            :placeholder="dataModal.table_use.placeholder"
                            :value-default="dataModal.table_use.value"
                            @inputValue="onChange($event, dataModal.table_use.id)"
                            :required="dataModal.table_use.required"
                            :disabled="dataModal.table_use.disable"
                    ></InputTextNormal>
                </div>
                <div class="col-sm-3 d-flex gap-3">
                    <InputTextNormal
                            :label="dataModal.type.label"
                            :id="dataModal.type.id"
                            :placeholder="dataModal.type.placeholder"
                            :value-default="dataModal.type.value"
                            @inputValue="onChange($event, dataModal.type.id)"
                            :required="dataModal.type.required"
                            :disabled="dataModal.type.disable"
                    ></InputTextNormal>
                </div>
            </div>
            <div class="modal-footer d-flex justify-content-center">
                <button class="btn btn-primary" @click="eventFile">Áp dụng</button>
            </div>
        </div>
    </div>
</div>
